// Module
var code = "<div class=\"wrapper\" ng-click=\"ctrl.onClick()\"> <div class=\"top\"> <span ng-include=\"ctrl.sTopIcon\"></span> </div> <div class=\"bottom\"> <span>{{ctrl.sTitle}}</span> <span ng-show=\"ctrl.sNotificationNumber\">({{ctrl.sNotificationNumber}})</span> <i class=\"glyphicon glyphicon-menu-right pull-right\"></i> </div> </div> ";
// Exports
module.exports = code;